<template>
  <div>
    <TextBlockWithHeader
        title="О компании"
        theme="dark"
        text="Общество с ограниченной ответственностью «Поисковый портал «Спутник» (ООО «ПП «Спутник», ИНН 7704304738,
        ОКВЭД 62.01)
        - российский разработчик программного обеспечения для крупных компаний и органов государственной власти.
        Дочернее общество ПАО «Ростелеком». Обществом разработан ряд продуктов для решения задач импортозамещения и
        создания дополнительных возможностей для российских пользователей, государственных ведомств и корпораций,
        интеграции реализованных продуктов.
    </br></br>
        Решения ООО «ПП «Спутник» используют в Почте России, ГИБДД РФ, ФИПС, Роспатенте, ПАО “Ростелеком”, ГК
        РТЛабс, Правительстве Москвы и в областных администрациях 85 регионов России, Министерстве здравоохранения
        Республики Алтай, ФГУП Информационно-аналитический центр поддержки ГАС «Правосудие» и других организациях."
    />

    <List :items="derectionsItems" title="Направления деятельности" />
  </div>
</template>

<script>
    import {TextBlockWithHeader, List} from 'sputnik-ui/src/index';

    export default {
      name: 'AboutPage',
      components: {
        TextBlockWithHeader,
        List
      },
      data() {
        return {
          derectionsItems: [
            { text: 'Создание и внедрение информационных систем федерального масштаба' },
            { text: 'Разработка программного обеспечения' },
            { text: 'Эксплуатация и функциональное тестирование ПО' },
            { text: 'Автоматизация ведомственных процессов' },
            { text: 'ИТ-консалтинг' },
            { text: 'Коды видов деятельности в области информационных технологий, осуществляемых организацией: 1.01, 2.01, 8.01' },
          ],
        }
      }
    };
</script>

<style lang="scss">
  .cover-wrapper .cover {
    background-color: initial;
  }
</style>
